module.exports = __webpack_public_path__ + "assets/img/mainItem03.6ee7c746.svg";